import { useEffect, useSyncExternalStore } from 'react'
import {
  getPredictionEntrySnapshot,
  refreshPredictionEntry,
  startPredictionEntrySync,
  subscribePredictionEntry,
} from './predictionEntryStore'

export function usePredictionUserEntry(predictionEnabled?: boolean) {
  const snapshot = useSyncExternalStore(
    subscribePredictionEntry,
    getPredictionEntrySnapshot,
    getPredictionEntrySnapshot,
  )

  useEffect(() => startPredictionEntrySync(predictionEnabled), [predictionEnabled])

  return {
    showPredictionEntry:
      predictionEnabled === true && snapshot.userEntryVisible,
    hasOpenEvents: snapshot.hasOpenEvents,
    userEntryVisible: snapshot.userEntryVisible,
    checked: snapshot.checked,
    refresh: () => refreshPredictionEntry(true),
  }
}
